import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IstoricDocGenerabil } from '../../../cerere.interface';
import { DataTableDirective } from 'angular-datatables';
import { helper } from 'src/environments/helper';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-istoric-document-generabil',
  templateUrl: './istoric-document-generabil.component.html',
  styleUrls: ['./istoric-document-generabil.component.scss'],
})
export class IstoricDocumentGenerabilComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;
  dtOptions: any = {};
  helper = helper;

  istoric!: IstoricDocGenerabil[];

  isLoading = false;
  filteredKeys: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: IstoricDocGenerabil[],
    private dialogRef: MatDialogRef<IstoricDocumentGenerabilComponent>
  ) {
    this.istoric = data;
  }

  ngOnInit(): void {
    this.renderDtOptions();
  }

  renderDtOptions() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      searching: false,
      lengthChange: false,
      language: environment.config.romanianLanguageDataTable,
    };
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }
}
